import React from 'react';
import Markdown from 'react-markdown';
import rehypeRaw from "rehype-raw";

const builtinFunctions = {
  formatAsCurrency: value =>
    value.toLocaleString('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
    }),
};

const TemplatedText = ({ source, variables = {}, functions = {}, ...props }) => {
  const allFunctions = { ...builtinFunctions, ...functions };
  let processedSource = source.nl ?? source;
  processedSource = processedSource.replace(/{{(\w+)\((\w+)\)}}/g, (match, func, value) =>
    func in allFunctions ? allFunctions[func](value in variables ? variables[value] : value) : '...'
  );
  processedSource = processedSource.replace(/{{(\w+)}}/g, (match, variable) =>
    variable in variables ? variables[variable] : '...'
  );
  processedSource = processedSource.replace(/{{(\w+).(\w+)}}/g, (match, variable, subvariable) => {
      if(variable in variables && subvariable in variables[variable]) {
          return variables[variable][subvariable]
      }
      return '...'
  });


    return <Markdown rehypePlugins={[rehypeRaw]} children={processedSource} {...props} />;
};

export default TemplatedText;
